import React, { useState } from 'react';
import { MacroShock } from '../types';
import { Card, CardHeader, CardContent } from './ui/Card';
import { Button } from './ui/Button';
import { Input, Label } from './ui/Forms';
import { PlusCircle, AlertTriangle } from 'lucide-react';
interface MacroShockFormProps {
  onAdd: (shock: Omit<MacroShock, 'id'>) => void;
}
export function MacroShockForm({
  onAdd
}: MacroShockFormProps) {
  const [name, setName] = useState('');
  const [year, setYear] = useState('1');
  const [liquidImpact, setLiquidImpact] = useState('-20');
  const [illiquidImpact, setIlliquidImpact] = useState('-10');
  const [realEstateImpact, setRealEstateImpact] = useState('-15');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!name || isNaN(Number(year))) return;
    onAdd({
      name,
      year: Number(year),
      liquidImpact: Number(liquidImpact) || 0,
      illiquidImpact: Number(illiquidImpact) || 0,
      realEstateImpact: Number(realEstateImpact) || 0,
      isActive: true
    });
    setName('');
    setYear('1');
    setLiquidImpact('-20');
    setIlliquidImpact('-10');
    setRealEstateImpact('-15');
  };
  return <Card data-id="element-1116">
      <CardHeader title="Add Macro-Economic Shock" subtitle="Simulate market crashes or booms at specific years" icon={<div className="bg-rose-600 p-2 rounded-lg shadow-sm" data-id="element-1118">
            <AlertTriangle className="w-4 h-4 text-white" data-id="element-1119" />
          </div>} data-id="element-1117" />
      <CardContent data-id="element-1120">
        <form onSubmit={handleSubmit} className="space-y-4" data-id="element-1121">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-1122">
            <div data-id="element-1123">
              <Label data-id="element-1124">Event Name</Label>
              <Input placeholder="e.g. 2008 Financial Crisis" value={name} onChange={e => setName(e.target.value)} required data-id="element-1125" />
            </div>
            <div data-id="element-1126">
              <Label data-id="element-1127">Year (from now)</Label>
              <Input type="number" min="0" step="1" value={year} onChange={e => setYear(e.target.value)} required data-id="element-1128" />
            </div>
          </div>

          <div data-id="element-1129">
            <p className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-3" data-id="element-1130">
              Impact on Asset Classes (%)
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-1131">
              <div data-id="element-1132">
                <Label data-id="element-1133">Liquid Assets</Label>
                <div className="relative" data-id="element-1134">
                  <Input type="number" step="0.1" value={liquidImpact} onChange={e => setLiquidImpact(e.target.value)} className="pr-8" data-id="element-1135" />
                  <span className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 text-sm" data-id="element-1136">
                    %
                  </span>
                </div>
              </div>
              <div data-id="element-1137">
                <Label data-id="element-1138">Illiquid Assets</Label>
                <div className="relative" data-id="element-1139">
                  <Input type="number" step="0.1" value={illiquidImpact} onChange={e => setIlliquidImpact(e.target.value)} className="pr-8" data-id="element-1140" />
                  <span className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 text-sm" data-id="element-1141">
                    %
                  </span>
                </div>
              </div>
              <div data-id="element-1142">
                <Label data-id="element-1143">Real Estate</Label>
                <div className="relative" data-id="element-1144">
                  <Input type="number" step="0.1" value={realEstateImpact} onChange={e => setRealEstateImpact(e.target.value)} className="pr-8" data-id="element-1145" />
                  <span className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 text-sm" data-id="element-1146">
                    %
                  </span>
                </div>
              </div>
            </div>
            <p className="text-xs text-slate-500 mt-2" data-id="element-1147">
              Use negative numbers for losses (e.g., -20) and positive numbers
              for gains (e.g., 10).
            </p>
          </div>

          <Button type="submit" className="w-full mt-2" data-id="element-1148">
            <PlusCircle className="w-4 h-4 mr-2" data-id="element-1149" />
            Add Shock Event
          </Button>
        </form>
      </CardContent>
    </Card>;
}